var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_Map.js
// module id = 610
// module chunks = 0 1 2 3 4 5 6 7 8